import {useEffect} from 'react'
import {usePageProps} from 'context/pageProps'
import {PageProps as AccommodationPageProps} from 'pages/Hotel/[hotelSlug]/[locale]'

import {useToggle} from '@vio/core/src/experiments/hooks/useToggle'

/**
 * Server toggle decisions aren't tracked to EVAS, so the client evaluates the same toggle
 * to record the exposure. Only views the server built preheat params for are exposed.
 */
export const useTrackSsrRoomsPreheat = () => {
  const toggle = useToggle()
  const {serverPreheatRoomsParams} = usePageProps() as AccommodationPageProps

  useEffect(() => {
    if (serverPreheatRoomsParams) toggle('feature-ssr-rooms-preheat')
  }, [serverPreheatRoomsParams, toggle])
}
